export default "__VITE_ASSET__1AVs3x7g__"